import { render } from "./ArticleChapter.vue?vue&type=template&id=0c0231a5&scoped=true"
import script from "./ArticleChapter.vue?vue&type=script&lang=js"
export * from "./ArticleChapter.vue?vue&type=script&lang=js"

import "./ArticleChapter.vue?vue&type=style&index=0&id=0c0231a5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0231a5"]])

export default __exports__